import { useTypeDefinition } from './type-definition-context';
import { methodRegExp } from './type-definition-entity';
import { TypeDefinitionToken } from './type-definition-token';

/** Renders a declaration of the type definition (e.g. name of a variable, function, class, interface, etc.) */
export const TypeDefinitionDeclaration = () => {
  const {
    declaration,
    entity,
    language
  } = useTypeDefinition();
  const isMethod = entity.title && methodRegExp.test(entity.title);
  let after: React.ReactNode = null;
  if (language === 'js') {
    if (declaration) {
      return <TypeDefinitionToken token={declaration + ': '} />;
    }
    if (entity.title?.startsWith('interface')) {
      return <TypeDefinitionToken token={entity.title + ' '} />;
    }
    if (isMethod) {
      after = <TypeDefinitionToken token=": " />;
    }
  }
  if (language === 'ruby') {
    if (declaration) {
      return <TypeDefinitionToken className="token" token={declaration + ': '} />;
    }
    if (entity.title?.startsWith('Hash')) {
      return <TypeDefinitionToken className="token" token={entity.key + ': '} />;
    }
    if (entity.title?.startsWith('class')) {
      return <TypeDefinitionToken token={entity.title} />;
    }
  }
  if (language === 'python') {
    if (declaration) {
      return <TypeDefinitionToken className="token" token={declaration + ': '} />;
    }
    if (isMethod) {
      after = <TypeDefinitionToken token=": " />;
    }
  }
  if (language === 'php') {
    if (entity.title?.startsWith('WorkOS\\') && !isMethod) {
      return <TypeDefinitionToken token={`class ${entity.key} `} />;
    }
    if (declaration) {
      return <TypeDefinitionToken className="token" token={`${entity.type} ${declaration} `} />;
    }
  }
  if (language === 'go') {
    if (declaration && (entity.title || entity.type)) {
      return <>
          <span className="token">{declaration}</span>{' '}
          <TypeDefinitionToken className="token go" token={entity.title || entity.type} />
        </>;
    }
  }
  if (language === 'dotnet') {
    if (entity.title?.startsWith('class')) {
      return <TypeDefinitionToken token={entity.title + '\n'} />;
    }
    if (entity.properties) {
      const token = entity.type ?? entity.key;
      const resolved = token.replace(/Task<(.+)>/, '$1');
      return <TypeDefinitionToken token={resolved + ' '} />;
    }
  }
  if (isMethod) {
    return <>
        {entity.title?.replace(/\(|\)/g, '').split(/(.+(?:\.|->|::))/).map((fragment, index, arr) => <TypeDefinitionToken key={index} token={fragment} className={`${index === arr.length - 1 ? 'token function' : 'token'}`} />)}
        {after}
      </>;
  }
  return null;
};